import { objectHasKeys, isNull, isNullOrUndefined } from '@/utils/comparators'

const hasSavedPaymentMethods = (state) => {
  if ((isNull(state.savedPaymentMethods) || state.savedPaymentMethods.length === 0) && (isNull(state.savedPaymentMethodsLegacy) || state.savedPaymentMethodsLegacy.length === 0)) return false
  return true
}

const getOtherPaymentMethods = (state, getters, rootState) => {
  if (!state.paymentMethodsLegacy) {
    return false
  }
  let paymentMethods = state.paymentMethodsLegacy.filter(v => {
    if (v.methodType === 'Bank Transfer') {
      let currencies = v.currencies.split(',')
      let countries = v.countries.split(',')
      return v.methodType === 'Bank Transfer' && currencies.includes(rootState.user.currency) && countries.includes(rootState.user.geolocation)
    }
  })

  for (var value of paymentMethods) {
    value.alias = value.method.name.split(' ')[0].toLowerCase()
  }

  return paymentMethods
}

const getPaymentMethodsLegacy = (state, getters, rootState) => {
  if (!state.paymentMethodsLegacy) {
    return false
  }

  const grouped = state.paymentMethodsLegacy.reduce((returnItem, item) => {
    if (item.sdk) (returnItem[item.sdk] = returnItem[item.sdk] || []).push(item)
    return returnItem
  }, {})

  if (grouped.length === 0) return false
  return grouped
}

const hasAutoTopUp = (state) => {
  if (!hasSavedCardLegacy(state)) {
    return false
  }
  if (Object.values(state.savedPaymentMethodsLegacy).find((a) => a.autoTopUpEnabled === true)) {
    return true
  } else {
    return false
  }
}

/* Legacy getters */
const getSelectedCardLegacy = (state) => {
  if (isNullOrUndefined(state.savedPaymentMethodsLegacy)) {
    return false
  }
  return Object.values(state.savedPaymentMethodsLegacy).find((a) => a.paymentInfoId === state.selectedPaymentMethod)
}

const getPrimaryCardLegacy = (state) => {
  if (hasPrimaryCardLegacy(state)) {
    return Object.values(state.savedPaymentMethodsLegacy).find((a) => a.isPrimary)
  }

  return null
}
const hasSavedCardLegacy = (state) => {
  if (isNull(state.savedPaymentMethodsLegacy)) {
    return false
  }

  return objectHasKeys(state.savedPaymentMethodsLegacy)
    ? Object.keys(state.savedPaymentMethodsLegacy).length > 0
    : false
}

const hasPrimaryCardLegacy = (state) => {
  if (isNull(state.savedPaymentMethodsLegacy)) {
    return false
  }

  return objectHasKeys(state.cards)
    ? Object.values(state.savedPaymentMethodsLegacy).filter((a) => a.isPrimary).length > 0
    : false
}
const getPrebookingInfo = (state) => {
  return state.prebookingInfo
}
const getPrebookingPaymentInfo = (state) => {
  return state.prebookingPaymentInfo
}
const getUsersSubsciption = (state) => {
  if (state.order) return state.order.existedSubscriptionsOfUser
}
const getProductsAvailabilityForSubscription = (state) => {
  if (state.order) return state.order.isProductAvailableForSubscription
}
const getTopupSubscription = (state) => {
  if (state.order) return state.order.subscription
}
export default {
  hasSavedPaymentMethods,
  getOtherPaymentMethods,
  getPaymentMethodsLegacy,
  hasAutoTopUp,
  getSelectedCardLegacy,
  getPrimaryCardLegacy,
  hasSavedCardLegacy,
  hasPrimaryCardLegacy,
  getPrebookingInfo,
  getPrebookingPaymentInfo,
  getUsersSubsciption,
  getProductsAvailabilityForSubscription,
  getTopupSubscription
}



// WEBPACK FOOTER //
// ./src/store/modules/checkout-v2/getters.js